export default "__VITE_ASSET__e1dde727__"